export default __webpack_public_path__ + "static/media/add-button.d86bb2ed.svg";